import { render, staticRenderFns } from "./CorporateSubscriberInfo.vue?vue&type=template&id=54ec7553&scoped=true&"
import script from "./CorporateSubscriberInfo.vue?vue&type=script&lang=js&"
export * from "./CorporateSubscriberInfo.vue?vue&type=script&lang=js&"
import style0 from "./CorporateSubscriberInfo.vue?vue&type=style&index=0&id=54ec7553&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec7553",
  null
  
)

export default component.exports